import { makeStyles } from '@mui/styles';
import NumberField from 'components/number-field';
import React, { CSSProperties, forwardRef } from 'react';

interface Props {
  value: number | null;
  disabled?: boolean;
  onChange: (value: number | null) => void;
  name: string;
  borderColor?: CSSProperties['backgroundColor'];
}

type StylesProps = {
  borderColor?: CSSProperties['backgroundColor'];
};

const useStyles = makeStyles((theme) => ({
  numberField: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: (props: StylesProps) =>
        props.borderColor ?? theme.palette.background.default,
      border: '1px solid lightgray',

      color: theme.palette.primary.dark,
      borderRadius: '5px',
      fontSize: '13px',
      display: 'flex',
      justifyContent: 'flex-end',

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'unset',
      },
      '& .MuiOutlinedInput-input ': {
        textAlign: 'right',
        padding: '8px 6px',
      },
    },
  },
}));

export const MoneyField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { onChange, disabled, name, value: fieldValue, borderColor, ...rest } = props;
  const classes = useStyles({ borderColor });

  return (
    <NumberField
      {...rest}
      name={name}
      customRef={ref}
      color="secondary"
      className={classes.numberField}
      onChange={(e) => {
        onChange(Number.parseFloat(e.target.value.replace(/[$,]/g, '')));
      }}
      isAllowed={undefined}
      prefix="$"
      disabled={disabled}
      onFocus={(e) => {
        const numberfloat = Number.parseFloat(e.target.value.replace(/[$,]/g, ''));
        if (numberfloat === 0) {
          onChange(null);
        }
      }}
      handleBlur={(e) => {
        const { value } = e.target;
        if (value === '') {
          onChange(0);
        }
      }}
      thousandSeparator
      variant="outlined"
      value={fieldValue}
    />
  );
});
